import { Fragment } from 'react';
import RutasBlog from './componentes/Rutas/Rutas.blog';

function App() {
  return (
    <Fragment>
      <RutasBlog/>
      
    </Fragment>
  );
}

export default App;
